import { render, staticRenderFns } from "./storyAdd.vue?vue&type=template&id=710e7560&scoped=true"
import script from "./storyAdd.vue?vue&type=script&lang=js"
export * from "./storyAdd.vue?vue&type=script&lang=js"
import style0 from "./storyAdd.vue?vue&type=style&index=0&id=710e7560&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710e7560",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('710e7560')) {
      api.createRecord('710e7560', component.options)
    } else {
      api.reload('710e7560', component.options)
    }
    module.hot.accept("./storyAdd.vue?vue&type=template&id=710e7560&scoped=true", function () {
      api.rerender('710e7560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/exercise/list/storyAdd.vue"
export default component.exports